import React from 'react';
import useParam from '../../../context/ParamContext';
import { AutoCompleteSelectUI, FormErrorUI, FormLabelUI, InputUI } from '../../Interface';
import { Field, useFormikContext } from 'formik';
import { getProjectOrderNumberName } from '../../../utils/getProjectOrderNumberName';
import DynamicPropertyField from '../../DynamicProperty/DynamicPropertyField';

const ProjectAddDialogFields = ({ autoCompleteOptions, dynProps }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();
  const { params } = useParam();

  const dynPropsParam = params.WORKSHEET_SHOW_DYN_PROPS_BY_PROPERTYID
    ? JSON.parse(params.WORKSHEET_SHOW_DYN_PROPS_BY_PROPERTYID)
    : [];

  return (
    <div className="grid grid-cols-6 gap-x-4 gap-y-3 lg:mx-4 mb-5 mt-2">
      <div className="lg:col-span-2 col-span-6">
        <Field
          type="text"
          name="projectName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectName} />}
          InputLabelProps={{ shrink: values.projectName !== '' }}
        />
      </div>
      <div className="col-span-6 lg:col-span-2">
        <Field
          type="text"
          name="orderNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text={getProjectOrderNumberName(params)} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.orderNumber} />}
          InputLabelProps={{ shrink: values.orderNumber !== '' }}
        />
      </div>
      <div className="col-span-6 lg:col-span-2">
        <Field
          type="autocomplete"
          name="projectTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('projectTypeId', newVal?.value ?? null).then(() => {
              validateField('projectTypeId');
            });
          }}
          InputLabelProps={{ shrink: values.projectTypeId !== '' }}
          selectedValue={values.projectTypeId}
          dataset={autoCompleteOptions.projectType}
        />
      </div>
      {dynPropsParam.length > 0 &&
        dynProps
          ?.filter((dynProp) => dynPropsParam.includes(dynProp.propertyId))
          ?.map((dynProp) => (
            <div className="col-span-6 lg:col-span-2">
              <DynamicPropertyField
                fieldData={dynProp}
                name={`dynamicFields.din_${dynProp.property.id}`}
                selectedValues={{}}
                showLabel={true}
              />
            </div>
          ))}
    </div>
  );
};

export default ProjectAddDialogFields;
